import { deleteReq, get, post } from '../../../infra/rest';
import requestConfig from '../../../shared/config/request';
import { urlCreator } from '../../../shared/utils/url-helpers';
import {
  CreateWAGroupPayload,
  CreateWAGroupResponse,
  WAGroupChatMeta,
  WAGroupMember,
  WAGroupMembersPaginationData,
  WAGroupMembersResponse,
  WAGroupMetaDataResponse,
} from '../typings/groups';

export const createWAGroupApi = async (payload: CreateWAGroupPayload): Promise<CreateWAGroupResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group`,
  });
  return post(url, { body: JSON.stringify(payload) }, true, false, true);
};

export const getWAGroupDetails = async (groupId: string): Promise<WAGroupChatMeta> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group/info`,
    query: {
      groupId: groupId,
    },
  });
  return get<WAGroupChatMeta>(url, undefined, true, false, true);
};

export const getWAGroupMembers = async (
  groupId: string,
  paginationData?: WAGroupMembersPaginationData
): Promise<WAGroupMembersResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group/participants`,
    query: {
      groupId,
    },
  });
  return get<WAGroupMembersResponse>(url, {}, true, false, true);
};

export const removeWAGroupMember = async (groupId: string, participantPhone: string): Promise<void> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group/participants`,
  });
  return deleteReq(
    url,
    {
      body: JSON.stringify({
        groupId,
        participantPhone,
      }),
    },
    true,
    false,
    true
  );
};

export const updateWAGroupDetails = async (
  groupId: string,
  payload: {
    subject?: string;
    description?: string;
    clientCustomGroupId?: string;
  }
) => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group/settings`,
    query: {
      groupId,
    },
  });

  return post(
    url,
    {
      body: JSON.stringify(payload),
    },
    true,
    false,
    true
  );
};

export const getWAGroupMetadata = (): Promise<WAGroupMetaDataResponse> => {
  const url = urlCreator({
    baseUrl: `${requestConfig.aiBotBaseUrl}/v1/wa-group/metadata`,
  });
  return get<WAGroupMetaDataResponse>(url, undefined, true, false, true);
};
